import React, { useState, useEffect, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { moveDayAdjustment } from '../../../../../redux/actions/plan';
import MaskedInput from 'react-text-mask';
import ReactLoading from 'react-loading';

const AsyncMDAView = lazy(() => import('./MDAView'));

const mapStateToProps = ({ plan, movePlan }) => ({
	updating: plan.updating,
	mdaSending: plan.mdaSending,
	mdaStatus: plan.mdaStatus,
	status: !!movePlan.currentPlan.mda_status
		? movePlan.currentPlan.mda_status
		: 'none',
});

const MoveDayAdjustments = props => {
	const [email, setEmail] = useState(false);
	const [emailError, setEmailError] = useState(false);
	const [sms, setSms] = useState(false);
	const [smsError, setSmsError] = useState(false);
	const [loading, setLoading] = useState([false, false]);

	useEffect(() => {
		if (!props.mdaSending && (loading[0] || loading[1]))
			setLoading([false, false]);
		//eslint-disable-next-line
	}, [props.mdaSending]);
	const sendEmailLink = () => {
		if (!!email && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
			setLoading([true, false]);
			props.moveDayAdjustment({
				type: 'email',
				data: email,
			});
		} else {
			setEmailError('Please enter a valid email address.');
		}
	};
	const sendSmsLink = () => {
		if (!!sms && sms.length === 14) {
			setLoading([false, true]);
			props.moveDayAdjustment({
				type: 'sms',
				data: sms,
			});
		} else {
			setSmsError('Please enter a valid phone number.');
		}
	};
	return (
		<div className="no-print admin-panel-green">
			<div>
				<h5 className="admin-panel-header" style={{ color: '#1B5E20' }}>
					MOVE DAY ADJUSTMENTS
				</h5>
			</div>
			{props.status === 'submitted' || props.status === 'accepted' ? (
				<div>
					<p>
						Current status: <b>{props.status}</b>
					</p>
					<Suspense fallback={''}>
						<AsyncMDAView />
					</Suspense>
				</div>
			) : (
				<div className="container p-0">
					<div>
						<p>
							Current status: <b>{props.status}</b>
						</p>
					</div>
					<div className="row">
						<div className="col-12 mb-3">
							<button
								type="button"
								className="btn-small primary float-right"
								disabled={props.mdaSending || props.planUpdating}
								onClick={() => props.moveDayAdjustment({ type: 'open' })}>
								{props.mdaSending ? (
									<ReactLoading
										type="spokes"
										className="m-auto"
										width={20}
										height={20}
									/>
								) : (
									'Go to Move Day Adjustments'
								)}
							</button>
							<p>View or send a link to Move Day Adjustments.</p>
						</div>
					</div>

					<div className="row">
						<div className="col-12 col-md-6">
							<input
								onChange={e => setEmail(e.target.value)}
								onFocus={() => setEmailError(false)}
								className={`col-8 pr-2 ${emailError && 'field-error'}`}
								type="email"
								placeholder="Email recipient"
							/>
							<button
								className="btn-small secondary col-4"
								type="button"
								onClick={sendEmailLink}
								disabled={props.mdaSending || props.planUpdating}>
								{loading[0] ? (
									<ReactLoading
										type="spokes"
										color="#000"
										className="m-auto"
										width={20}
										height={20}
									/>
								) : (
									'Send Email'
								)}
							</button>
						</div>
						<div className="col-12 col-md-6">
							<MaskedInput
								onChange={e => setSms(e.target.value)}
								onFocus={() => setSmsError(false)}
								type="phone"
								style={{ minHeight: '33px' }}
								className={`col-8 pr-2 ${!!smsError && 'field-error'}`}
								placeholder="Phone Number"
								guide={false}
								mask={[
									'(',
									/[1-9]/,
									/\d/,
									/\d/,
									')',
									' ',
									/\d/,
									/\d/,
									/\d/,
									'-',
									/\d/,
									/\d/,
									/\d/,
									/\d/,
								]}
							/>
							<button
								className="btn-small secondary col-4"
								type="button"
								onClick={sendSmsLink}
								disabled={props.mdaSending || props.planUpdating}>
								{loading[1] ? (
									<ReactLoading
										type="spokes"
										color="#000"
										className="m-auto"
										width={20}
										height={20}
									/>
								) : (
									'Send SMS'
								)}
							</button>
						</div>
						{!!emailError && (
							<div className="col-12">
								<p className="text-danger">{emailError}</p>
							</div>
						)}
						{!!smsError && (
							<div className="col-6 offset-md-6">
								<p className="text-danger">{smsError}</p>
							</div>
						)}
						{props.mdaStatus.email && (
							<div className="col-12">
								<p className="text-success">Email Sent!</p>
							</div>
						)}
						{props.mdaStatus.sms && (
							<div className="col-12">
								<p className="text-success">Sms Sent!</p>
							</div>
						)}
					</div>
				</div>
			)}
			<style jsx>{`
				.admin-panel-header {
					font-family: ProximaNovaBold;
					text-align: center;
				}
				.admin-panel-green {
					border-top: 10px solid #1b5e20;
					margin: 10px 0;
					padding: 20px;
					background: #c8e6c9;
					width: 100%;
				}
				.btn-small {
					padding: 0 1rem;
				}
				input {
					min-height: 33px;
				}
				.primary {
					min-width: 203px;
				}
				.secondary {
					width: 100%;
				}
			`}</style>
		</div>
	);
};

export default connect(mapStateToProps, { moveDayAdjustment })(
	MoveDayAdjustments
);
